import { render } from "./PlayerRounds.vue?vue&type=template&id=ca070ff2"
import script from "./PlayerRounds.vue?vue&type=script&lang=js"
export * from "./PlayerRounds.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__